import React, { useState } from "react"
import { Link } from "gatsby"
import { css } from "@emotion/core"
import MediaQuery from "react-responsive"

import Burger from "./Burger"
import Menu from "./Menu"

const headerStyles = css`
  height: 70px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 var(--size-5);
  overflow: hidden;

  @media (min-width: 1000px) {
    padding: 0 var(--size-10);
  }
`

const navigationStyles = css`
  display: flex;
  flex-flow: column nowrap;
  margin-bottom: 0;

  @media (min-width: 800px) {
    flex-flow: row nowrap;
  }

  > * {
    margin: 0 calc(var(--size-4) * 0.5);

    &:last-child {
      margin-right: 0;
    }
  }
`

const navigationItemStyles = css`
  margin-bottom: 0;
  font-family: var(--font-family-heading);
  font-size: var(--size-5);
  font-weight: 600;
  color: var(--colour-heading);
  margin-bottom: var(--size-6);
  text-align: right;

  @media (min-width: 800px) {
    font-size: 14px;
    margin-bottom: 0;
    text-align: left;
  }
`

const mobileMenu = css`
  @media (min-width: 800px) {
    display: none;
  }
`

const desktopMenu = css`
  display: none;
  @media (min-width: 800px) {
    display: initial;
  }
`

const Header = () => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <header
        css={headerStyles}
        style={{
          background: `white`,
          // marginBottom: `1.45rem`,
        }}
      >
        <div>
          <Link to="/">
            <svg
              css={css`
                vertical-align: top;
              `}
              width="137"
              height="33"
              viewBox="0 0 137 33"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.116 30H1.98V27.972H2.964C5.196 27.972 6.336 26.712 6.336 24.912C6.336 23.076 5.196 21.84 2.964 21.84H1.116V30ZM1.98 27.216V22.608H2.916C4.752 22.608 5.436 23.568 5.436 24.912C5.436 26.256 4.752 27.216 2.916 27.216H1.98ZM12.9238 30H13.7878V27.228H18.1558V30H19.0198V21.84H18.1558V26.436H13.7878V21.84H12.9238V30ZM29.7758 30.096C32.1038 30.096 33.9758 28.38 33.9758 25.92C33.9758 23.46 32.1038 21.744 29.7758 21.744C27.4598 21.744 25.5878 23.46 25.5878 25.92C25.5878 28.38 27.4598 30.096 29.7758 30.096ZM29.7758 29.316C27.8798 29.316 26.4878 27.864 26.4878 25.92C26.4878 23.976 27.8798 22.524 29.7758 22.524C31.6838 22.524 33.0758 23.976 33.0758 25.92C33.0758 27.864 31.6838 29.316 29.7758 29.316ZM41.8431 30H42.7071V22.608H45.2151V21.84H39.3351V22.608H41.8431V30ZM54.7626 30.096C57.0906 30.096 58.9626 28.38 58.9626 25.92C58.9626 23.46 57.0906 21.744 54.7626 21.744C52.4466 21.744 50.5746 23.46 50.5746 25.92C50.5746 28.38 52.4466 30.096 54.7626 30.096ZM54.7626 29.316C52.8666 29.316 51.4746 27.864 51.4746 25.92C51.4746 23.976 52.8666 22.524 54.7626 22.524C56.6706 22.524 58.0626 23.976 58.0626 25.92C58.0626 27.864 56.6706 29.316 54.7626 29.316ZM69.3263 30.096C70.8623 30.096 71.9543 29.556 72.5543 28.968V26.124H69.3143V26.892H71.7383V28.572C71.2343 28.98 70.4423 29.316 69.3263 29.316C67.3463 29.316 65.9543 27.864 65.9543 25.92C65.9543 23.976 67.3343 22.524 69.2543 22.524C70.2623 22.524 70.9823 22.836 71.5103 23.388L72.0983 22.8C71.4263 22.08 70.4303 21.744 69.2543 21.744C66.8783 21.744 65.0543 23.46 65.0543 25.92C65.0543 28.38 66.8903 30.096 69.3263 30.096ZM82.7562 27.492C83.8842 27.036 84.4602 26.076 84.4602 24.852C84.4602 23.088 83.3082 21.84 81.0762 21.84H79.2402V30H80.1042V27.84H81.0762C81.3642 27.84 81.6642 27.816 81.9402 27.768L83.5122 30H84.5322L82.7562 27.492ZM80.1042 27.084V22.608H81.0282C82.8642 22.608 83.5602 23.568 83.5602 24.852C83.5602 26.136 82.8762 27.084 81.0282 27.084H80.1042ZM90.3995 30H91.2515L91.7915 28.632H95.9195L96.4715 30H97.3835L93.9275 21.756H93.7835L90.3995 30ZM92.0915 27.888L93.5315 24.264C93.6875 23.88 93.8555 23.292 93.8555 23.292C93.8555 23.292 94.0115 23.88 94.1675 24.264L95.6075 27.888H92.0915ZM103.746 30H104.61V27.972H105.594C107.826 27.972 108.966 26.712 108.966 24.912C108.966 23.076 107.826 21.84 105.594 21.84H103.746V30ZM104.61 27.216V22.608H105.546C107.382 22.608 108.066 23.568 108.066 24.912C108.066 26.256 107.382 27.216 105.546 27.216H104.61ZM115.554 30H116.418V27.228H120.786V30H121.65V21.84H120.786V26.436H116.418V21.84H115.554V30ZM131.098 30H131.986V27.408L135.01 21.84H134.11L131.902 25.896C131.734 26.22 131.554 26.724 131.554 26.724C131.554 26.724 131.386 26.208 131.206 25.896L128.986 21.84H128.014L131.098 27.444V30Z"
                fill="#666666"
              />
              <path
                d="M55.476 13H57.294V6.646C57.294 5.962 57.222 4.882 57.222 4.882C57.222 4.882 57.834 5.8 58.302 6.358L61.38 10.066H61.596L64.674 6.358C65.178 5.8 65.772 4.882 65.772 4.882C65.772 4.882 65.7 5.962 65.7 6.646V13H67.518V0.633999H67.32L61.524 7.474L55.674 0.633999H55.476V13ZM76.1941 13.162C78.4801 13.162 80.2081 12.172 81.2701 10.552L79.8121 9.526C79.0201 10.696 77.8861 11.452 76.1941 11.452C73.6561 11.452 71.8561 9.49 71.8561 6.88C71.8561 4.27 73.6561 2.326 76.1941 2.326C77.7961 2.326 78.9481 3.028 79.6321 4.09L81.0901 3.046C80.0101 1.426 78.3901 0.616 76.1941 0.616C72.7201 0.616 69.9121 3.226 69.9121 6.88C69.9121 10.534 72.7201 13.162 76.1941 13.162ZM89.2953 13.162C91.5813 13.162 93.2733 12.316 94.0653 11.596V6.826H89.0253V8.5H92.3193V10.66C91.6353 11.128 90.5553 11.452 89.2953 11.452C86.5233 11.452 84.7233 9.49 84.7233 6.88C84.7233 4.27 86.5053 2.326 89.0613 2.326C90.5193 2.326 91.4193 2.794 92.1213 3.532L93.3993 2.254C92.4093 1.138 90.9333 0.616 89.0613 0.616C85.4253 0.616 82.7793 3.226 82.7793 6.88C82.7793 10.534 85.4793 13.162 89.2953 13.162ZM96.6791 13H104.239V11.326H98.5871V0.76H96.6791V13ZM111.509 13.162C115.001 13.162 117.809 10.534 117.809 6.88C117.809 3.226 115.001 0.598 111.509 0.598C107.999 0.598 105.191 3.226 105.191 6.88C105.191 10.534 107.999 13.162 111.509 13.162ZM111.509 11.452C108.953 11.452 107.135 9.49 107.135 6.88C107.135 4.27 108.953 2.308 111.509 2.308C114.065 2.308 115.865 4.27 115.865 6.88C115.865 9.49 114.065 11.452 111.509 11.452ZM120.271 13H122.161V0.76H120.271V13ZM134.713 13.126H134.947V0.76H133.183V7.492C133.183 8.176 133.309 9.256 133.309 9.256C133.309 9.256 132.643 8.392 132.175 7.888L125.425 0.633999H125.173V13H126.937V6.25C126.937 5.494 126.811 4.486 126.811 4.486C126.811 4.486 127.477 5.332 127.963 5.854L134.713 13.126Z"
                fill="#333333"
              />
              <path
                d="M7.2 13.162C9.486 13.162 11.214 12.172 12.276 10.552L10.818 9.526C10.026 10.696 8.892 11.452 7.2 11.452C4.662 11.452 2.862 9.49 2.862 6.88C2.862 4.27 4.662 2.326 7.2 2.326C8.802 2.326 9.954 3.028 10.638 4.09L12.096 3.046C11.016 1.426 9.396 0.616 7.2 0.616C3.726 0.616 0.918 3.226 0.918 6.88C0.918 10.534 3.726 13.162 7.2 13.162ZM14.4311 13H16.3391V9.04H22.2251V13H24.1331V0.76H22.2251V7.348H16.3391V0.76H14.4311V13ZM32.9733 9.22C34.5753 8.518 35.4213 7.222 35.4213 5.332C35.4213 2.524 33.5313 0.76 30.1473 0.76H27.0873V13H28.9953V9.85H30.1473C30.4893 9.85 30.8313 9.814 31.1733 9.778L33.3693 13H35.5653L32.9733 9.22ZM28.9953 8.212V2.434H30.0753C32.4693 2.434 33.4773 3.496 33.4773 5.332C33.4773 7.15 32.5053 8.212 30.0753 8.212H28.9953ZM38.0578 13H39.9478V0.76H38.0578V13ZM46.2724 13.162C48.5764 13.162 50.2504 11.92 50.2504 9.778C50.2504 7.816 49.1344 6.844 47.0464 5.926L46.2544 5.566C45.0124 5.026 44.4904 4.612 44.4904 3.694C44.4904 2.866 45.1024 2.272 46.0744 2.272C47.0284 2.272 47.5684 2.65 48.0364 3.46L49.5304 2.542C48.7924 1.228 47.6944 0.616 46.0744 0.616C44.0404 0.616 42.6364 1.912 42.6364 3.73C42.6364 5.62 43.7164 6.52 45.4984 7.312L46.3084 7.672C47.6404 8.266 48.3604 8.734 48.3604 9.796C48.3604 10.804 47.4784 11.47 46.2364 11.47C44.7424 11.47 44.0044 10.714 43.4284 9.76L41.8624 10.624C42.5464 12.01 43.9504 13.162 46.2724 13.162Z"
                fill="#333333"
              />
            </svg>
          </Link>
        </div>

        {/* <MediaQuery maxDeviceWidth={799}> */}
        <div css={mobileMenu}>
          <Burger open={open} setOpen={setOpen} />
          <Menu open={open} setOpen={setOpen}>
            <ul css={navigationStyles}>
              <Link to="/" onClick={() => setOpen(!open)}>
                <li css={navigationItemStyles}>Home</li>
              </Link>
              <Link to="/portfolio" onClick={() => setOpen(!open)}>
                <li css={navigationItemStyles}>Portfolio</li>
              </Link>
              <Link to="/videos" onClick={() => setOpen(!open)}>
                <li css={navigationItemStyles}>Videos</li>
              </Link>
              {/* <Link to="/blog" onClick={() => setOpen(!open)}>
                <li css={navigationItemStyles}>Blog</li>
              </Link> */}
              <Link to="/about" onClick={() => setOpen(!open)}>
                <li css={navigationItemStyles}>About Chris</li>
              </Link>
              <Link to="/faqs" onClick={() => setOpen(!open)}>
                <li css={navigationItemStyles}>FAQs</li>
              </Link>
              <Link to="/packages-contact" onClick={() => setOpen(!open)}>
                <li css={navigationItemStyles}>Packages & Contact</li>
              </Link>
            </ul>
          </Menu>
        </div>
        {/* </MediaQuery> */}
        {/* <MediaQuery minDeviceWidth={800}> */}
        <div css={desktopMenu}>
          <ul css={navigationStyles}>
            <Link to="/" onClick={() => setOpen(!open)}>
              <li css={navigationItemStyles}>Home</li>
            </Link>
            <Link to="/portfolio">
              <li css={navigationItemStyles}>Portfolio</li>
            </Link>
            <Link to="/videos" onClick={() => setOpen(!open)}>
              <li css={navigationItemStyles}>Videos</li>
            </Link>
            {/* <Link to="/blog" onClick={() => setOpen(!open)}>
              <li css={navigationItemStyles}>Blog</li>
            </Link> */}
            <Link to="/about">
              <li css={navigationItemStyles}>About Chris</li>
            </Link>
            <Link to="/faqs">
              <li css={navigationItemStyles}>FAQs</li>
            </Link>
            <Link to="/packages-contact">
              <li css={navigationItemStyles}>Packages & Contact</li>
            </Link>
          </ul>
        </div>
        {/* </MediaQuery> */}
      </header>
    </>
  )
}

Header.propTypes = {}

Header.defaultProps = {}

export default Header
